import styled from 'styled-components';

const Form = styled.form`
  display: block;
  padding-top: 40px;
`;

export default Form;
